import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AnalyticsPageModel } from "../../shared/model/analyticsPage";
import { CheckboxModel } from "../../shared/model/checkbox.model";
import { DataOrigin } from "../../shared/model/DataOrigin";
import { DefaultPageComponent } from "../../shared/page/default-page.component";
import { AnalyticsPageService } from "../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../shared/service/comunicator-native/return-native/return-native";
import { JourneyService } from "../../shared/service/journey/journey.service";
import { Term } from "../../shared/service/terms/model/term.model";
import { TermsFactoryService } from "../../shared/service/terms/terms-factory-service";
import { UserSignupFactoryService } from "../../shared/service/user-signup/user-signup-factory-service";
import { TrackTypes } from "../../shared/service/journey/tracks/model/track-types";
import { UserInvestorParseData } from "../../shared/service/journey/tracks/cadastro-investidor-v2/util/user-investor-parse-data";
import { IncomeWealthService } from "../../income-wealth/service/income-wealth.service";
import { AnalyticsGA4PageService } from "../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { DomainOrigin } from "../../shared/service/user-signup/model/domain-origin";
import { OpportunitiesForYouTestAbService } from "../../shared/service/opportunities-for-you-test-ab/opportunities-for-you-test-ab.service";
import { LocalStorageService } from "../../shared/service/storage/storage.service";
import { AbWebview } from "../../../app/shared/enums/ab-webview.enum";

@Component({
  selector: "app-terms",
  templateUrl: "./terms.component.html",
  styleUrls: ["./terms.component.scss"],
})
export class TermsComponent extends DefaultPageComponent implements OnInit {
  headerId = "terms";
  titlePage = "Termos e propostas";
  startStage = "";
  endStage = "";
  @ViewChild("contentScroll") contentScroll: ElementRef;
  checkboxList: CheckboxModel[] = [
    new CheckboxModel(
      "terms",
      "Li e aceito os termos e propostas",
      "Li e aceito os termos e propostas",
      false
    ),
  ];
  selectCheckbox: CheckboxModel[] = [];
  acceptedTerms = "";
  buttonEnable = false;
  labelButton = "Continuar";
  focusId: string;
  dataOrigin = DataOrigin.Mobile;
  dataUserOrigin;
  loading = false;
  loadingVerify = false;
  sentData = false;
  approved = false;
  voicePagePost = false;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  listTerms: Term[] = [
    {
      title: "Regras e parâmetros de atuação da Itaú Corretora de Valores S.A.",
      type: "regras",
    },
    {
      title:
        "Proposta de intermediação de negócios nas bolsas de valores, de mercadorias e de futuros",
      type: "bolsa",
    },
    {
      title: "Declaração do Cliente",
      type: "declarac",
    },
    {
      title: "Termo de condição de acesso",
      type: "condic",
    },
  ];

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    private termsFactoryService: TermsFactoryService,
    private userSignupFactoryService: UserSignupFactoryService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private incomeWealthService: IncomeWealthService,
    private storage: LocalStorageService,
    public opportunitiesService: OpportunitiesForYouTestAbService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    const dataOriginTrack = this.journeyService.getCurrentTrack(this.headerId)
      ?.parameters?.dataOrigin;

    this.dataUserOrigin = dataOriginTrack
      ? dataOriginTrack
      : this.dataUserOrigin;
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    // this.opportunitiesService.initData(AbWebview.ABWEBVIEW_GROWTHCSI_SUCESSO_CADASTRO_DE_CORRETORA);
  }

  ionViewWillEnter() {
    this.focusPageWithDetail(this.focusId);
    this.resetDataPage();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  getPageId(): string {
    return this.headerId;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  verifyStatusBtn() {
    return this.selectCheckboxNoEmpty();
  }

  setSelectCheckbox($event: CheckboxModel[]) {
    this.selectCheckbox = $event;
    if (this.selectCheckboxNoEmpty()) {
      this.buttonEnable = true;
      setTimeout(() => {
        this.contentScroll.nativeElement.scrollTop =
          this.contentScroll.nativeElement.scrollHeight;
      }, 1);
    }
  }

  selectCheckboxNoEmpty() {
    return this.selectCheckbox[0]?.checked;
  }

  clickNext() {
    // toggle inclusão tela de custódia/rlp
    if (JSON.parse(localStorage.getItem('getToggle')) === true || JSON.parse(localStorage.getItem('getToggle')) === "true") {
      this.redirectToEndPage();
    } else {
      this.sendUserData();
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  openDetail(item: any) {
    this.focusId = item.index;
    this.router.navigateForward("details", {
      state: {
        data: item,
      },
    });
  }

  getTerm(item: any) {
    const termHasDescription: Term[] = this.listTerms.filter(
      (term: Term) => term?.description && term.type === item.type
    );

    if (termHasDescription.length > 0) {
      this.openDetail({
        ...termHasDescription[0],
        title: termHasDescription[0].titleContent,
        index: item.index,
      });
    } else {
      this.loading = true;

      this.termsFactoryService
        .getService(this.dataOrigin)
        .getTerms(item.type)
        .then((term: Term) => {
          if (term) {
            const termDescription = term?.description
              .split("\r\n")
              .filter((str: string) => str.replace(/\s/g, "") !== "")
              .map((str: string) => {
                if (str.includes("_____________________")) {
                  return `<p class='bar'>${str}</p>`;
                }
                return `<p>${str}</p>`;
              })
              .join("");

            this.updateLisTerms(item.type, {
              ...term,
              description: termDescription,
            });

            this.loading = false;
            this.openDetail({
              ...term,
              titleContent: term.title,
              description: termDescription,
              index: item.index,
              pageLoadedOnlyScreenReader: true,
            });
          }
        })
        .catch(() => (this.loading = false));
    }
  }

  updateLisTerms(type: string, term: Term) {
    this.listTerms.forEach(element => {
      if (element.type === type) {
        element.titleContent = term.title,
        element.description = term.description
      }
      return element;
    });
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage?.terms;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathTermos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage?.action,
      it_eventlabel: this.analyticsPage?.back,
      it_pagename: this.analyticsPage?.terms,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  showVoicePagePost() {
    this.voicePagePost = true;
    setTimeout(() => (this.voicePagePost = false), 100);
  }

  sendUserData() {
      console.log("sendUserData called");
      const initialData = {
          incomeEquity: { ...this.incomeWealthService.getInitialDataTaxResidence() }
      };
      console.log("Initial data:", initialData);
  
      const userSignUpData = UserInvestorParseData.formatToUserSignup(this.journeyService.registratioJourney.data, initialData);
      console.log("Formatted user sign-up data:", userSignUpData);
  
      this.labelButton = 'Validando iToken...';
      this.loadingVerify = true;
  
      const id_investidor = this.journeyService.registratioJourney.data.idInvestor;
      console.log("Investor ID:", id_investidor);
  
      const appIos = document.querySelector('.plt-ios') ? true : false;
      console.log("Is iOS app:", appIos);
  
      if (!appIos) {
          this.showVoicePagePost();
      }
  
      if (!this.sentData) {
          this.sentData = true;
          console.log("Sending data to backend...");
          this.userSignupFactoryService.getService(this.dataUserOrigin).postUserSignup(userSignUpData, id_investidor)
              .then((data: any) => {
                  console.log("Response from backend:", data);
                  if (data?.data?.code === 200 || data?.data?.code === 202 || data?.data?.success === true) {
                      console.log("Backend response indicates success");
                      setTimeout(() => {
                          this.setStateSuccess();
                          setTimeout(() => {
                              this.redirectToEndPage();
                          }, 2000);
                      }, 3000);
                  } else {
                      console.log("Backend response indicates failure, retrying...");
                      this.setStateRetry();
                      this.sentData = false;
                  }
              })
              .catch((error) => {
                  console.error("Error during backend call:", error);
                  this.setStateRetry();
                  this.sentData = false;
              });
      } else {
          console.log("Data has already been sent, skipping...");
      }
  }

  resetDataPage() {
    if (this.approved) {
      this.approved = false;
      this.loadingVerify = false;
      this.labelButton = "Continuar";
      this.checkboxList[0].checked = false;
    }
  }

  setStateRetry() {
    this.labelButton = "Tentar novamente";
    this.loadingVerify = false;
    this.approved = false;
    this.showVoicePagePost();
  }

  setStateSuccess() {
    this.labelButton = "Tudo certo!";
    this.approved = true;
    this.loadingVerify = false;
    this.showVoicePagePost();
  }

  redirectToEndPage() {
    // const nextPage = this.journeyService.getNextRoute(this.getPageId());
    // this.setDataAnalysis();
    // if (nextPage) {
    //   this.router.navigateForward(nextPage);
    // } else {
    //   this.router.navigateForward(["data-analysis"]);
    // }
    this.setDataAnalysis();
    if (JSON.parse(localStorage.getItem('getToggle')) === true || JSON.parse(localStorage.getItem('getToggle')) === "true") {
      this.router.navigateForward(["rlp"]);
    } else {
      this.router.navigateForward(["data-analysis"]);
    }
  }

  setDataAnalysis() {
    let dataAnalisys = null;
    const journey = this.journeyService.journey;
    const name =
      this.journeyService.registratioJourney.data?.profileData?.name ===
        undefined ||
      this.journeyService.registratioJourney.data?.profileData?.name === ""
        ? this.journeyService.registratioJourney.data.personalData.name
        : this.journeyService.registratioJourney.data?.profileData?.name;

    const setJourneyBasic = [
      TrackTypes.BASIC_V2,
      TrackTypes.BASIC_PERSONAL_V2,
      TrackTypes.BASIC_MARITAL_V2,
      TrackTypes.BASIC_INCOME_V2,
      TrackTypes.BASIC_ADDRESS_V2,
      TrackTypes.BASIC_PROFILE_V2,
      TrackTypes.BASIC_PROFESSIONAL_V2,
    ];
    const setJourneyUpdate = [
      TrackTypes.UPDATE_REGISTRATION,
      TrackTypes.UPDATE_ADDRESS,
      TrackTypes.UPDATE_INCOME,
      TrackTypes.UPDATE_INCOME_CONTA_ION,
      TrackTypes.UPDATE_MARITAL,
      TrackTypes.UPDATE_PROFESSIONAL,
      TrackTypes.UPDATE_PROFILE,
    ];

    const currentJourneyBasic = setJourneyBasic.find((x) => x === journey);
    const currentJourneyUpdate = setJourneyUpdate.find((x) => x === journey);

    const analyticsPage = {
      pageName: this.analyticsPage?.dataAnalysisStatus,
      action: this.analyticsPage?.action,
      dataAnalysisStatusEvent: this.analyticsPage?.dataAnalysisStatusEvent,
      dataAnalysisStatusLabel: this.analyticsPage?.dataAnalysisStatusLabel,
    };

    const analyticsPageGA4 = {
      paramDefautl: {
        event_name: this.analyticsPageGA4.eventNameScreenView,
        custom_path: this.analyticsPageGA4.customPathTelaSucesso,
        implementation_team: this.analyticsPageGA4.implementationTeam,
      },
    };

    switch (journey) {
      case currentJourneyBasic:
        dataAnalisys = {
          titleContent: `${name}, seus dados foram enviados para análise.`,
          description: `<p>Em alguns minutos*, você poderá investir na bolsa.
        Enquanto isso, aproveite para navegar pelo app e conhecer mais o íon Itaú.</p>
        <p>Caso seu cadastro não seja concluído com sucesso, você receberá uma notificação
        com as instruções para regularizá-lo.</p><p>*Aplicável para dias úteis.</p>`,
          icon: "../../../assets/images/svg/new-data-analysis-vector.svg",
          analyticsPage,
          analyticsPageGA4,
          likert: true,
          nomeJornada: "ION - JORNADA CADASTRO INVESTIDOR",
          navegJornada: "MENU > COMPLETE SEU CADASTRO",
        };
        return this.storage.set("data-analisys-basic", dataAnalisys);
      case currentJourneyUpdate:
        dataAnalisys = {
          titleContent: `${name}, seus dados estão em análise.`,
          description: `<p>Em alguns minutos*, você poderá investir na bolsa. Enquanto isso, aproveite para navegar pelo app e
          conhecer mais o íon Itaú.</p><p>Caso seu cadastro não seja concluído com sucesso, você receberá uma notificação com as instruções
          para regularizá-lo.</p><p>*Aplicável para dias úteis.</p>`,
          icon: "../../../assets/images/svg/new-data-analysis-vector.svg",
          analyticsPage,
          analyticsPageGA4,
          backNative: true,
        };
        return this.storage.set("data-analisys", dataAnalisys);
      default:
        return "";
    }
  }
}
